(function () {
  const STORAGE_KEY = 'custom_shopify_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  }

  function isWishlisted(handle) {
    return getWishlist().includes(handle);
  }

  function updateButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      const handle = button.dataset.productHandle;

      const active = wishlist.includes(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const icon = button.querySelector('.wishlist-icon');

      if (icon) {
        icon.innerHTML = active ? '♥' : '♡';
      }
    });
  }

  function updateCount() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(element => {
      element.textContent = count;

      if (count > 0) {
        element.classList.add('has-items');
      } else {
        element.classList.remove('has-items');
      }
    });
  }

  function toggleWishlist(handle) {
    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);

    updateButtons();
    updateCount();

    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          wishlist: wishlist
        }
      })
    );
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-button]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;

    if (!handle) return;

    toggleWishlist(handle);
  });

  function init() {
    updateButtons();
    updateCount();
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);

  window.CustomWishlist = {
    get: getWishlist,
    toggle: toggleWishlist,
    refresh: init
  };
})();